import { render } from "./defaultBreadcrumb.vue?vue&type=template&id=98f57ab0"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__